const Joi = require("joi");

const forgotPasswordSchema = (data) => {
  const schema = Joi.object({
    email: Joi.string()
      .trim()
      .email({ tlds: { allow: false } })
      .pattern(
        new RegExp(
          /^(?!.*\.\.)[a-zA-Z0-9._%+-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z]{2,})+$/
        )
      )
      .required()
      .messages({
        "string.email": "Please enter valid email.",
        "string.pattern.base": "Please enter valid email.",
        "string.empty": "Please enter email.",
        "any.required": "Please enter email.",
      }),
  }).unknown(true);

  return schema.validate(data, {
    abortEarly: false,
  });
};

module.exports = forgotPasswordSchema;
